import AlarmIcon from '@mui/icons-material/Alarm';
import BlockIcon from '@mui/icons-material/Block';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import PauseCircleIcon from '@mui/icons-material/PauseCircle';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import SkipNextIcon from '@mui/icons-material/SkipNext';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Chip } from '@mui/material';
import { displayStatus, STATUS_META } from './taskUi';

export const STATUS_ICONS = {
    block: BlockIcon,
    warning: WarningAmberIcon,
    alarm: AlarmIcon,
    play: PlayCircleIcon,
    dot: FiberManualRecordIcon,
    person_off: PersonOffIcon,
    next: SkipNextIcon,
    pause: PauseCircleIcon,
    hourglass: HourglassEmptyIcon,
    check: CheckCircleIcon,
    cancel: CancelIcon,
};

/** Status as icon + text (never color alone). Pass a row, or an explicit status key. */
const TaskStatusChip = ({ row, status, size = 'small' }) => {
    const key = status || displayStatus(row);
    const meta = STATUS_META[key];
    if (!meta) return null;
    const Icon = STATUS_ICONS[meta.icon];
    return (
        <Chip
            size={size}
            variant="outlined"
            color={meta.color}
            icon={<Icon sx={{ fontSize: '0.95rem' }} />}
            label={meta.label}
            sx={{ fontSize: '0.72rem', fontWeight: 500 }}
        />
    );
};

export default TaskStatusChip;
